import { createSlice } from '@reduxjs/toolkit';

import { getShipments, getPackingItems, getShippingList, updatePackingItems, getPackingList, downloadSamplePackingList, uploadShipmentPackingList, recoverShipments, getShippingLabel, getDownloadSkusLabel, getEditTrackingId, saveEditTrackingId } from '../../apis';

export const ShipmentManagement = createSlice({
    name: 'shipmentManagement',
    initialState: {
        IsLoading: false,
        data : [],
        shipmentManagementError: '',
        packingItemsListData: {},
        shippingListUrl: '',
        shippingListSuccess: false,
        packingListUrl: '',
        samplePackingListUrl: '',
        uploadPackingShipmentListSuccess: '',
        updatePackingListSuccess: '',
        recoverShipmentsSuccess: '',
        shippingLabelUrls: '',
        downloadSkusLabelUrl: '',
        editTrackingIdData : {},
        editTrackingSuccess : false,
    },

    reducers: {
        emptyShippingListUrl: (state, action) => {
            return {
                ...state,
                shippingListUrl: action.payload
            }
        },
        emptyPackingListUrl: (state, action) => {
            return {
                ...state,
                packingListUrl: action.payload
            }
        },
        emptyPackingItemsListData: (state, action) => {
            return {
                ...state,
                packingItemsListData: action.payload
            }
        },
        clearError: (state, action) => {
            return {
                ...state,
                shipmentManagementError: action.payload
            }
        },
        updateUploadShipmentPackingListSuccess: (state, action) => {
            return {
                ...state,
                uploadPackingShipmentListSuccess: action.payload
            }
        },
        clearSamplePackingListUrl: (state, action) => {
            return {
                ...state,
                samplePackingListUrl: action.payload
            }
        },
        clearRecoverShipmentsSuccess: (state, action) => {
            return {
                ...state,
                recoverShipmentsSuccess: action.payload
            }
        },
        clearShippingLabelUrls: (state, action) => {
            return {
                ...state,
                shippingLabelUrls: action.payload
            }
        },
        clearDownloadSkusLabelUrl: (state, action) => {
            return {
                ...state,
                downloadSkusLabelUrl: action.payload
            }
        },
        clearUpdatePackingListSuccess: (state, action) => {
            return {
                ...state,
                updatePackingListSuccess: action.payload
            }
        },
        clearEditTrackingSuccess: (state, action) => {
            return {
                ...state,
                editTrackingSuccess: action.payload
            }
        },
    },

    extraReducers: (builder) => {
        builder.addCase(getShipments.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getShipments.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.shipmentManagementError = '';
            state.data = action.payload.data
        })
        builder.addCase(getShipments.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(getShippingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getShippingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.shipmentManagementError = '';
            state.shippingListUrl = action.payload.data;
            state.shippingListSuccess = true;
        })
        builder.addCase(getShippingList.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(getPackingItems.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getPackingItems.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.shipmentManagementError = '';
            state.packingItemsListData = action.payload.data;
        })
        builder.addCase(getPackingItems.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(updatePackingItems.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(updatePackingItems.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.updatePackingListSuccess = true;
            state.shipmentManagementError = '';
        })
        builder.addCase(updatePackingItems.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(getPackingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getPackingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.packingListUrl = action.payload.data;
            state.shipmentManagementError = '';
        })
        builder.addCase(getPackingList.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(downloadSamplePackingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(downloadSamplePackingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.shipmentManagementError = '';
            state.samplePackingListUrl = action.payload.data;
        })
        builder.addCase(downloadSamplePackingList.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(uploadShipmentPackingList.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(uploadShipmentPackingList.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.uploadPackingShipmentListSuccess = true;
            state.shipmentManagementError = '';
        })
        builder.addCase(uploadShipmentPackingList.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(recoverShipments.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(recoverShipments.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.recoverShipmentsSuccess = true;
        })
        builder.addCase(recoverShipments.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(getEditTrackingId.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(getEditTrackingId.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.editTrackingIdData = action.payload.data;
            state.shipmentManagementError = '';
        })
        builder.addCase(getEditTrackingId.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        builder.addCase(saveEditTrackingId.pending, (state, action) => {
            state.IsLoading = true;
        })
        builder.addCase(saveEditTrackingId.fulfilled, (state, action) => {
            state.IsLoading = true;
            state.editTrackingSuccess = true;
            state.shipmentManagementError = '';
        })
        builder.addCase(saveEditTrackingId.rejected, (state, action) => {
            state.shipmentManagementError = action.payload.message
            state.IsLoading = false;
        })
        // builder.addCase(getShippingLabel.pending, (state, action) => {
        //     state.IsLoading = true;
        // })
        // builder.addCase(getShippingLabel.fulfilled, (state, action) => {
        //     state.IsLoading = true;
        //     state.shippingLabelUrls = action.payload.data;
        // })
        // builder.addCase(getShippingLabel.rejected, (state, action) => {
        //     state.shipmentManagementError = action.payload.message
        //     state.IsLoading = false;
        // })
        // builder.addCase(getDownloadSkusLabel.pending, (state, action) => {
        //     state.IsLoading = true;
        // })
        // builder.addCase(getDownloadSkusLabel.fulfilled, (state, action) => {
        //     state.IsLoading = true;
        //     state.downloadSkusLabelUrl = action.payload.data;
        // })
        // builder.addCase(getDownloadSkusLabel.rejected, (state, action) => {
        //     state.shipmentManagementError = action.payload.message
        //     state.IsLoading = false;
        // })
    }
})

export const { emptyShippingListUrl, emptyPackingItemsListData, emptyPackingListUrl, clearError, updateUploadShipmentPackingListSuccess, clearSamplePackingListUrl, clearRecoverShipmentsSuccess, clearShippingLabelUrls, clearDownloadSkusLabelUrl, clearUpdatePackingListSuccess,clearEditTrackingSuccess } = ShipmentManagement.actions

export default ShipmentManagement.reducer